export default __webpack_public_path__ + "static/media/thumb-tb-page.fef2ece5.png";